<script>
  // import {json} from './assets/js/FuturaAnalyticsJSON.js'
  import Options from './components/Options'
  import Parameters from './components/Parameters'

  export default {
    name: 'App',
    components: {
      Options,
      Parameters
    },
    data() {
      return {
        parametersGeneral: {},
        parametersPerCompany: {},
        parametersOthers: [],
        parametersDisplay: [],
        loading: true
      }
    },
    mounted() {
      document.title = 'Futura Analytics';
      let response;

      this.axios
      .get('http://flash.futurasistemas.com.br/Analytics/FuturaAnalyticsJSON.JSON')
      .then((res) => {
        response = res.data;

        for (const key in response.PARAMETROS) {
          if (response.PARAMETROS.hasOwnProperty(key)) {
            this.demystifyCode(response.PARAMETROS[key], this.parametersGeneral);
          }
        }
        for (const key in response.PARAMETROS_IMPRESSO) {
          if (response.PARAMETROS_IMPRESSO.hasOwnProperty(key)) {
            this.demystifyCode(response.PARAMETROS_IMPRESSO[key], this.parametersPerCompany);
          }
        }

        this.loading = false;
      });
    },
    methods: {
      demystifyCode(response, parameters) {
        let 
          code,
          group,
          tabs,
          tab0,
          tab1,
          order,
          object,
          objectItem;

        code  = response.NOME.split('-')[0].trim();
        
        if (code.search(/[0-9]/) == -1) {
          this.parametersOthers.push(response);
        } else {
          group = code.match(/^[a-z]+|[0-9]+/i)[0];

          code  = code.replace(/^[a-z]+[0-9]+|[0-9]+/i, '');
          tabs  = code.match(/[0-9]+(\.[0-9]+)?(\.[0-9]+)?$/)[0].split('.');
          order = parseInt(tabs.pop(), 10);

          tab0 = tabs[0] ? tabs[0] : false;
          tab1 = tabs[1] ? tabs[1] : false;
          
          object = {
            GRUPO: group,
            ITENS: []
          };

          objectItem = Object.assign({
            ORDEM: order
          }, response);

          if (typeof parameters[object.GRUPO] == 'undefined') {
            parameters[object.GRUPO] = object;
          }

          if ( tab0 && typeof parameters[object.GRUPO][tab0] == 'undefined') {
            parameters[object.GRUPO][tab0] = [];
          }

          if ( tab1 && typeof parameters[object.GRUPO][tab0][tab1] == 'undefined') {
            parameters[object.GRUPO][tab0][tab1] = [];
          }
          
          if (tab1) {
            parameters[object.GRUPO][tab1][order] = objectItem;
          } else if (tab0) {
            parameters[object.GRUPO][tab0][order] = objectItem;
          } else {
            parameters[object.GRUPO].ITENS[order] = objectItem;
          }
        }
      },
      setParameters(arr) {
        this.parametersDisplay = arr;
      }
    }
  }
</script>

<template>
  <div id="app">
    <section class="container">
      <aside class="container__aside">
        <img src="./assets/img/logotipo.png" alt="" class="logotipo">
        <Options 
          v-if="!loading"
          :parametersGeneral="parametersGeneral"
          :parametersPerCompany="parametersPerCompany"
          :parametersOthers="parametersOthers"
          @parameters="setParameters"
        ></Options>
      </aside>
      <article 
        v-if="!loading"
        class="container__article"
      >
        <Parameters :parametersDisplay="parametersDisplay"></Parameters>
      </article>
      <div 
        v-else
        class="loading"
      >
        <div class="bouncingLoader">
          <div></div>
        </div>
      </div>
    </section>
  </div>
</template>


<style>
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,500');
  * {
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }
  span {
    display: inline-block;
  }

  .container {
    display: flex;
    width: 100%;
    overflow: hidden;
  }
  .container__aside,
  .container__article {
    height: 100vh;
    padding: 1rem 0;
  }
  .container__aside {
    width: 280px;
    border-right: 1px solid #DEE2E6;
    overflow-y: auto;
  }
  .container__article {
    flex-grow: 1;
    overflow-y: scroll;
  }
  .logotipo {
    display: block;
    padding: 1.5rem;
  }

  .loading {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    flex-grow: 1;
    align-self: center;
  }
  @keyframes bouncing-loader {
    to {
      opacity: 0.1;
      transform: translate3d(0, -16px, 0);
    }
  }

  .bouncingLoader > div, .bouncingLoader:before, .bouncingLoader:after {
    display: inline-block;
    width: 13px;
    height: 13px;
    background: #5778F3;
    border-radius: 50%;
    animation: bouncing-loader 0.6s infinite alternate;
  }
  .bouncingLoader > div, .bouncingLoader:before, .bouncingLoader:after {
    content: " ";
  }
  .bouncingLoader > div {
    margin: 0 5px;
  }
  .bouncingLoader > div {
    animation-delay: 0.2s;
  }
  .bouncingLoader:after {
    animation-delay: 0.4s;
  }

</style>
